import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TrackingPageOrderItemCard } from '../../tracking-page.model';

@Component({
  selector: 'app-tracking-page-order-item',
  templateUrl: './tracking-page-order-item.component.html',
  styleUrls: ['./tracking-page-order-item.component.scss']
})
export class TrackingPageOrderItemComponent {
  @Input() itemCard: TrackingPageOrderItemCard;
  @Input() item: any;
  @Input() selectedId: any;
  @Output() selectBlock = new EventEmitter();

  get titleStyles() {
    const { fontSize, alignment } = this.itemCard.title;
    return {
      'fontSize.px': fontSize,
      'text-align': alignment
    };
  }

  get infoStyles() {
    const { fontSize, alignment } = this.itemCard.info;
    return {
      'fontSize.px': fontSize,
      'justify-content':
        alignment === 'left'
          ? 'start'
          : alignment === 'right'
          ? 'end'
          : alignment
    };
  }

  selectItemBlock(id: string, event: any) {
    event.stopPropagation();
    this.selectBlock.emit(id);
  }
}
